export enum AGENT_TYPE {
  "AUH" = 300,
  "AUM" = 301,
  "HBA" = 302,
  "AIA" = 310,
  "EMPLOYEE" = 311,
  "BROKER" = 400
};
